import { createStore } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import setPath from 'lodash/set';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import { PRESET_NUM_OF_DAYS } from './lib';

export const createAnalyticsStore = () => {
  const today = dayjs().utc().startOf('day');
  const from = today.subtract(PRESET_NUM_OF_DAYS[2].days, 'day');

  const store = {
    data: {
      first: {
        dateRange: { from: from.toISOString(), to: today.toISOString() },
      },
      second: {
        dateRange: { from: '', to: '' },
        month: '',
      },
    },
    selectedNumOfDays: PRESET_NUM_OF_DAYS[2],
    comparisonRangeDays: 0,
    comparisonRangeChosen: null,
    isCustomOffset: false,
    isComparing: false,
    isPresetMode: false,
    isLoading: false,
    error: null,
  };

  return createStore(
    subscribeWithSelector(
      immer((set, get) => ({
        ...store,

        update: (updates) =>
          set((state) => {
            if (typeof updates === 'object' && !Array.isArray(updates)) {
              /**
               * Updates the state with the new values provided in the updates object.
               * This allows for partial updates to the state without replacing the entire object.
               * @param {Object} updates - An object containing key-value pairs to update in the state.
               * @example
               * update({ 'isLoading': true, 'data.seo.title': 'New Title' });
               */
              for (const [path, value] of Object.entries(updates)) {
                setPath(state, path, value);
              }
            } else {
              throw new Error('update must receive only ONE(1) parameter which must be an object with key-value pairs');
            }
          }),

        updateData: (updates) =>
          set((state) => {
            if (typeof updates === 'object' && !Array.isArray(updates)) {
              /**
               * Updates the data object with the new values provided in the updates object.
               * This allows for partial updates to the data without replacing the entire object.
               *
               * @param {Object} updates - An object containing key-value pairs to update in the data.
               * @example
               * updateData({ 'data.content': newContent, 'data.seo.title': 'New Title' });
               */
              for (const [path, value] of Object.entries(updates)) {
                setPath(state.data, path, value);
              }
            } else {
              throw new Error('updateData must receive only ONE(1) parameter which must be an object with key-value pairs');
            }
          }),
      })),
    ),
  );
};
